import { AxiosInstance } from "axios";
import { LocalStorage } from "quasar";
import ma_objects from "src/modules/ma/classes/ma_objects";

export class BaseApiService {
  get store() {
    return (window as any).$store;
  }
  get settings() {
    return (window as any).$store.getters["settings/allSettings"];
  }
  get app_ref(): string | undefined {
    return typeof this.settings.app_ref == "string"
      ? this.settings.app_ref
      : ma_objects.ref2str(this.settings.app_ref);
  }
  get url(): string | undefined {
    return this.settings.services[this.service]?.url;
  }
  get jwt(): string | undefined {
    return "Bearer " + this.settings.services[this.service]?.jwt;
  }
  get dialogId() {
    return LocalStorage.getItem("dialogId");
  }

  service: string;
  http!: AxiosInstance;

  constructor(service: string) {
    this.service = service;
  }
}
